import React from 'react';
import { Navigate } from 'react-router-dom';
import { legacyRedirectRoutes } from './legacyRedirects';
import { publicRoutes } from './publicRoutes';
import { technicianRoutes } from './technicianRoutes';
import { carretRoutes } from './carretRoutes';

// 18 Oct 2026: the new UI (Carret) is the only UI. The old screens are no
// longer routed (nor built) — their addresses open the matching new page
// (legacyRedirects). Kept: the public pages and capture links, and the
// technician app (its own login).
export const appRoutes = [
  ...publicRoutes,
  ...technicianRoutes,
  ...carretRoutes,
  ...legacyRedirectRoutes,
  { path: '*', element: <Navigate to="/" replace /> },
];

export { publicRoutes, technicianRoutes, carretRoutes };
